











































































import Vue from 'vue';
import L from '@/plugins/leaflet';
import YolpRepository from '@/repository/yolp';
import yolp from '@/repository/yolp';
import * as MapUtils from '@/utils/MapUtils';
import * as GenreJson from '@/utils/GenreJson';

const didMount = async (self: any) => {
  self.map = L.map('map_view', {
    center: L.latLng(self.lat, self.lon),
    zoom: 15,
  })
    .addLayer(L.tileLayer('http://{s}.tile.osm.org/{z}/{x}/{y}.png'))
    .on('click', (p: any) => onClickToMap(self, p.latlng.lat, p.latlng.lng));
  loadStore(self, 1);
  loadStation(self, 1);
};

const loadStore = async (self: any, start: number) => {
  self.loading = true;
  self.info = { Total: 0, Start: 1, Count: 0 };
  const [result, info] = await YolpRepository.localserch(
    self.lat,
    self.lon,
    start,
    {
      gc: GenreJson.transformCode(MapUtils.enable(self.genres) || '') || '',
    },
  );
  const cards: any[] = self.cards;
  for (const store of result || []) {
    const [storeLon, storeLat] = store.Geometry.Coordinates.split(',');
    const latlon = new L.LatLng(storeLat, storeLon);
    cards.push({
      image: store.Property.LeadImage,
      gid: store.Gid,
      name: store.Name,
      marker: L.marker(latlon),
      flex: { xs6: true, sm6: true, md3: true },
    });
    self.map.addLayer(cards[cards.length - 1].marker);
  }
  self.loading = false;
  self.info = info;
  self.cards = cards;
};

const loadStation = async (self, start) => {
  const [result, info] = await YolpRepository.localserch(
    self.lat,
    self.lon,
    start,
    {
      image: false,
      gc: '0306006',
      dist: 1,
    },
  );
  self.stations = [];
  for (const store of result || []) {
    store.Name = store.Name.split('　').pop();
    if (!store.Name.endsWith('駅')) {
      continue;
    }
    const [storeLon, storeLat] = store.Geometry.Coordinates.split(',');
    const latlon = new L.LatLng(storeLat, storeLon);
    self.stations.push({
      gid: store.Gid,
      name: store.Name,
      marker: L.marker(latlon),
    });
  }
};

const onClickToCard = (self: any, p: any) => {
  p.marker
    .addTo(self.map)
    .bindPopup(L.popup().setContent(p.name))
    .openPopup();
  self.map.setView([p.marker.getLatLng().lat, p.marker.getLatLng().lng]);
};

const onClickToMap = (self: any, lat: number, lon: number) => {
  self.lat = lat;
  self.lon = lon;
  for (const card of self.cards) {
    self.map.removeLayer(card.marker);
  }
  self.map.setView([self.lat, self.lon], 15);
  self.cards = [];
  loadStore(self, 0);
  loadStation(self, 0);
};

const onClickToStation = (self: any, p: L.Marker) => {
  onClickToMap(self, p.getLatLng().lat, p.getLatLng().lng);
};

const onClickToGenre = (self: any, p: any) => {
  const enable = MapUtils.enableParent(self.genres) || '';
  self.genres = MapUtils.clear(self.genres);
  if (enable !== p) {
    for (const genre of Object.keys(self.genres)) {
      self.genres[genre].selected =
        p === genre ? !self.genres[genre].selected : false;
    }
    if (self.genres[enable]) {
      const g = self.genres[enable];
      for (const genre of Object.keys(g.children)) {
        g.children[genre].selected =
          p === genre ? !g.children[genre].selected : false;
        if (g.children[genre].selected) {
          self.genres[enable].selected = true;
        }
      }
    }
  }
  onClickToMap(self, self.lat, self.lon);
};

const handleScroll = (self, event) => {
  const map = document.querySelector(`.map`);
  const scrollY = window.scrollY;
  const innerHeight = window.innerHeight;
  const clientHeight = map ? map.clientHeight : 0;
  if (!self.loading && scrollY + innerHeight > clientHeight) {
    const nextStart = self.info.Start + self.info.Count;
    if (nextStart < self.info.Total) {
      loadStore(self, nextStart);
    }
  }
};

export default Vue.extend({
  mounted() {
    didMount(this);
  },
  data() {
    return {
      lat: 35.6825,
      lon: 139.752778,
      info: { Total: 0, Start: 1, Count: 0 },
      folding: false,
      loading: true,
      cards: [],
      stations: [],
      genres: GenreJson.nameList(),
    };
  },
  methods: {
    handleScroll(event) {
      handleScroll(this, event);
    },
    onClickToCard(event) {
      onClickToCard(this, event);
    },
    onClickToStation(event) {
      onClickToStation(this, event);
    },
    onClickToGenre(event) {
      onClickToGenre(this, event);
    },
    genreStr() {
      return MapUtils.enable(this.genres);
    },
    otherGenre() {
      const g = MapUtils.enableParent(this.genres) || '';
      return (this.genres[g] || {}).children || {};
    },
  },
});
